/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_6_Analytics_DescInputs */

const en_privacy_section_6_analytics_desc = /** @type {(inputs: Privacy_Section_6_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`retained according to Google Analytics default settings (14 months)`)
};

const lv_privacy_section_6_analytics_desc = /** @type {(inputs: Privacy_Section_6_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saglabāti saskaņā ar Google Analytics noklusējuma iestatījumiem (14 mēneši)`)
};

/**
* | output |
* | --- |
* | "retained according to Google Analytics default settings (14 months)" |
*
* @param {Privacy_Section_6_Analytics_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_6_analytics_desc = /** @type {((inputs?: Privacy_Section_6_Analytics_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_6_Analytics_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_6_analytics_desc(inputs)
	return en_privacy_section_6_analytics_desc(inputs)
});